import { render, staticRenderFns } from "./FollowMenu.vue?vue&type=template&id=dbaffe7e&scoped=true"
import script from "./FollowMenu.vue?vue&type=script&lang=js"
export * from "./FollowMenu.vue?vue&type=script&lang=js"
import style0 from "./FollowMenu.vue?vue&type=style&index=0&id=dbaffe7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaffe7e",
  null
  
)

export default component.exports